export const giftList = (theme) => ({
    gifts: {
        textAlign: "center",
        overflow: "hidden",
    },
    container: {
        [theme.breakpoints.down("sm")]: {
            padding: 0,
        },
    },
    title: {
        paddingBottom: theme.spacing(4),
    },
    subtitle: {
        paddingBottom: theme.spacing(4),
    },
    slider: {},
    gift: {
        height: "100%",
        padding: "2px",
        margin: "0",
        [theme.breakpoints.down("sm")]: {
            maxWidth: 350,
        },
    },
    mobileSingleGift: {
        marginLeft: "auto",
        marginRight: "auto",
    },
});
